import logoHorizontal from '../../assets/imagens/logo-horizontal - sem_fundo.png';
import { BUSINESS_INFO } from '../../constants';
import { dispararConversaoWhatsApp } from '../../utils/gtag';
import './footer.scss';

export default function Footer() {
  const handleWhatsApp = () => {
    dispararConversaoWhatsApp(() => {
      window.open(BUSINESS_INFO.whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  };

  const handleInstagram = () => {
    window.open('https://instagram.com/eco.lavanderiaexpress', '_blank', 'noopener,noreferrer');
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <img src={logoHorizontal} alt="Eco Lavanderia Express" className="footer-logo" />
            <p className="footer-description">
              Lavanderia moderna com autoatendimento e serviço completo. Cuidado e atenção em cada peça.
            </p>
            <div className="social-links">
              <button onClick={handleWhatsApp} className="social-btn" aria-label="WhatsApp">
                <i className="ri-whatsapp-line"></i>
              </button>
              <button onClick={handleInstagram} className="social-btn" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </button>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Navegação</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('inicio')}>Início</button></li>
              <li><button onClick={() => scrollToSection('servicos')}>Serviços</button></li>
              <li><button onClick={() => scrollToSection('precos')}>Preços</button></li>
              <li><button onClick={() => scrollToSection('localizacao')}>Localização</button></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Contato</h4>
            <ul className="footer-info">
              <li>
                <i className="ri-map-pin-line"></i>
                <span>Av. Álvares Cabral, 894<br />Lourdes, BH - MG</span>
              </li>
              <li>
                <i className="ri-phone-line"></i>
                <span>(31) 99990-1010</span>
              </li>
              <li>
                <i className="ri-time-line"></i>
                <span>Seg a Dom: 6h às 23h</span>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Formas de Pagamento</h4>
            <div className="payment-methods">
              <div className="payment-item">
                <i className="ri-bank-card-line"></i>
                <span>Cartão de Crédito</span>
              </div>
              <div className="payment-item">
                <i className="ri-bank-card-2-line"></i>
                <span>Cartão de Débito</span>
              </div>
              <div className="payment-item">
                <i className="ri-qr-code-line"></i>
                <span>PIX</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Eco Lavanderia Express. Todos os direitos reservados.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="readdy-link">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}